export default __webpack_public_path__ + "static/media/pokemon_logo_PNG9.49d2693d.png";